import Swal, {SweetAlertOptions, SweetAlertIcon} from "sweetalert2";

const swalPopUp = (title: string, text: string, icon: SweetAlertIcon) => {

    const scrollWidth = window.innerWidth - document.body.offsetWidth;                                                                               //Manejo de estilos para que no se mueva el navbar al aparecer el popup de sweetalert
    const contMenu = document.querySelector(".contMenu") as HTMLElement;
    if ((scrollWidth > 0 &&  window.innerWidth > window.innerHeight) || (window.innerWidth > window.innerHeight && window.innerWidth < 1200)) {      //Pantalla de pc (con scroll) o de celu acostado 
        contMenu.style.width = ((window.innerWidth - scrollWidth) * 0.8) + "px"; 
    } else {
        contMenu.style.width = "100%";                                                                                                               //Pantalla tactil portrait (sin scroll) 
    }
    
    const options : SweetAlertOptions = {               // Agregar la clase .swal2-icon-content {
        icon: icon,                                     // color: #ff5e15; } Sino los iconos de warning e info no se ven
        title: title,
        text: text,
        confirmButtonColor: "#284b63",
        iconColor: "#284b63",
        color: "#284b63",
        scrollbarPadding: true,
        customClass: {
            confirmButton: "sweetConfirmBoton",
        },
    };

    Swal.fire(options);
};

export {swalPopUp};